export const SNOWPACK_PUBLIC_PACKAGE_VERSION = "9.3.0";
export const SNOWPACK_PUBLIC_GETHARVEST_HOST = "getharvest.com";
export const SNOWPACK_PUBLIC_HARVESTAPP_PLATFORM_HOST = "platform.harvestapp.com";
export const SNOWPACK_PUBLIC_HARVESTAPP_V2_API_URL = "api.harvestapp.com/v2";
export const SNOWPACK_PUBLIC_HARVEST_ID_HOST = "id.getharvest.com";
export const SNOWPACK_PUBLIC_HARVEST_ID_V2_API_URL = "id.getharvest.com/api/v2";
export const SNOWPACK_PUBLIC_WEBSOCKET_SERVICE_HOST = "harvestapp-websocket.harvestapp.com";
export const SNOWPACK_PUBLIC_GTM_ID = "GTM-5B6RVD";
export const SNOWPACK_PUBLIC_SCHEME = "https";
export const SNOWPACK_PUBLIC_bugsnag_token = "4fdb3b8c1c84c966eb2a379928672998";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;